import * as React from "react";
import { forwardRef } from "react";
const SvgCountry = (props, ref) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" ref={ref} {...props}><path fill="currentColor" fillRule="evenodd" d="M16.06 2 8.774 5.924l3.628 6.753 7.837-4.488-4.667-1.524L16.06 2Zm-1.29 18.896L6.914 6.257 4.857 7.361 12.711 22l2.058-1.104Z" clipRule="evenodd" /></svg>;
const ForwardRef = forwardRef(SvgCountry);
export default ForwardRef;